import React, { useEffect } from 'react';
import { useParams, useOutletContext, useNavigate } from 'react-router-dom';
import { ProjectOutletContext } from '@/types/project';

/**
 * ProjectPageEditorPage - Direct page URL handler
 * Redirects to the pages route with openPage parameter for backwards compatibility
 */
const ProjectPageEditorPage: React.FC = () => {
  const { pageId } = useParams<{ pageId: string }>();
  const { project } = useOutletContext<ProjectOutletContext>();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (project?.id && pageId) {
      console.log('[ProjectPageEditorPage] Redirecting to pages route with openPage parameter:', pageId);
      // Redirect to pages route with openPage parameter
      navigate(`/project/${project.id}/pages?openPage=${pageId}`, { replace: true });
    }
  }, [project?.id, pageId, navigate]);
  
  if (!project || !pageId) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-600 dark:text-gray-300">
          Page not found.
        </p>
      </div>
    );
  }
  
  // Show loading while redirecting
  return (
    <div className="text-center py-12">
      <p className="text-gray-600 dark:text-gray-300">
        Opening page...
      </p>
    </div>
  );
};

export default ProjectPageEditorPage; 